export default {"src":"/_next/static/media/seperator_line_icon.588db3bf.svg","height":116,"width":2,"blurWidth":0,"blurHeight":0};